  // 版本校验
  function compareVersions(v1, v2) {
    if (typeof v1 !== "string" || typeof v2 !== "string") {
      throw new Error("版本号必须为字符串类型");
    }

    const parts1 = v1.trim().split(".");
    const parts2 = v2.trim().split(".");

    const len = Math.max(parts1.length, parts2.length);

    for (let i = 0; i < len; i++) {
      const num1 = parseInt(parts1[i], 10) || 0;
      const num2 = parseInt(parts2[i], 10) || 0;

      if (num1 > num2) {
        return 1;
      } else if (num1 < num2) {
        return -1;
      }
    }

    return 0;
  }

export default {
  //返回是否安卓终端
  isAndroid: () => {
    return (
      navigator.userAgent.indexOf("Android") > -1 ||
      navigator.userAgent.indexOf("Adr") > -1
    );
  },

  // 格式化数字 千位符
  formatNumber: (num) => {
    return parseFloat(num).toLocaleString();
  },


  // 判断版本号是否大于目标版本号
  isVersionGreaterThan: (current, target) => {
    return compareVersions(current, target) === 1;
  },

  // 判断版本号是否大于等于目标版本号
  isVersionGte: (current, target) => {
    return compareVersions(current, target) >= 0;
  },
};



// WEBPACK FOOTER //
// ./src/js/common.js